/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EasyClaimCaseState = {
	New: 'New',
	PictureUpload: 'PictureUpload',
	BeforeCompletion: 'BeforeCompletion',
	Completion: 'Completion',
	BeforeAudit: 'BeforeAudit',
	Audit: 'Audit',
	AuditRejected: 'AuditRejected',
	AuditApproval: 'AuditApproval',
	BeforeFinished: 'BeforeFinished',
	Finished: 'Finished',
	ClaimantRequest: 'ClaimantRequest',
	SimpleAudit: 'SimpleAudit',
	AfterSimpleAudit: 'AfterSimpleAudit',
	BeforeSimpleAudit: 'BeforeSimpleAudit',
	SimpleAuditApproval: 'SimpleAuditApproval',
	SimpleAuditApproved: 'SimpleAuditApproved',
	SimpleAuditDisapproved: 'SimpleAuditDisapproved',
	AuditApproved: 'AuditApproved',
	AuditDisapproved: 'AuditDisapproved',
	PictureUploadTimeouted: 'PictureUploadTimeouted',
	SimpleAuditApprovalTimeout: 'SimpleAuditApprovalTimeout',
	AuditApprovalTimeout: 'AuditApprovalTimeout',
	Hidden: 'Hidden',
	Failed: 'Failed',
	RuleEngine: 'RuleEngine',
	PolicyCheckVerification: 'PolicyCheckVerification',
	PolicyCheckRobot: 'PolicyCheckRobot',
	ManualCompletion: 'ManualCompletion',
	Analyzing: 'Analyzing',
	PolicyCheckVerificationSupervision: 'PolicyCheckVerificationSupervision',
	PictureReupload: 'PictureReupload',
} as const;
export type EasyClaimCaseState = (typeof EasyClaimCaseState)[keyof typeof EasyClaimCaseState];

export function instanceOfEasyClaimCaseState(value: any): boolean {
	for (const key in EasyClaimCaseState) {
		if (Object.prototype.hasOwnProperty.call(EasyClaimCaseState, key)) {
			if (EasyClaimCaseState[key as keyof typeof EasyClaimCaseState] === value) {
				return true;
			}
		}
	}
	return false;
}

export function EasyClaimCaseStateFromJSON(json: any): EasyClaimCaseState {
	return EasyClaimCaseStateFromJSONTyped(json, false);
}

export function EasyClaimCaseStateFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EasyClaimCaseState {
	return json as EasyClaimCaseState;
}

export function EasyClaimCaseStateToJSON(value?: EasyClaimCaseState | null): any {
	return value as any;
}

export function EasyClaimCaseStateToJSONTyped(
	value: any,
	ignoreDiscriminator: boolean
): EasyClaimCaseState {
	return value as EasyClaimCaseState;
}
